import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bb220ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "atendimentosDashboard",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = { id: "imgBack" }
const _hoisted_8 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":""}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M23.4375 3.75H18.75C18.75 1.68164 17.0684 0 15 0C12.9316 0 11.25 1.68164 11.25 3.75H6.5625C5.00977 3.75 3.75 5.00977 3.75 6.5625V27.1875C3.75 28.7402 5.00977 30 6.5625 30H23.4375C24.9902 30 26.25 28.7402 26.25 27.1875V6.5625C26.25 5.00977 24.9902 3.75 23.4375 3.75ZM15 2.34375C15.7793 2.34375 16.4062 2.9707 16.4062 3.75C16.4062 4.5293 15.7793 5.15625 15 5.15625C14.2207 5.15625 13.5938 4.5293 13.5938 3.75C13.5938 2.9707 14.2207 2.34375 15 2.34375ZM22.1016 15.9258L13.7227 24.2344C13.4473 24.5098 13.002 24.5039 12.7266 24.2285L7.88672 19.3477C7.61133 19.0723 7.61719 18.627 7.89258 18.3516L9.55664 16.6992C9.83203 16.4238 10.2773 16.4297 10.5527 16.7051L13.248 19.4238L19.459 13.2598C19.7344 12.9844 20.1797 12.9902 20.4551 13.2656L22.1074 14.9297C22.3828 15.2109 22.377 15.6504 22.1016 15.9258Z",
  fill: "#203972"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M15 2.34375C15.7793 2.34375 16.4063 2.9707 16.4063 3.75C16.4063 4.5293 15.7793 5.15625 15 5.15625C14.2207 5.15625 13.5938 4.5293 13.5938 3.75C13.5938 2.9707 14.2207 2.34375 15 2.34375ZM22.1016 15.9258L13.7227 24.2344C13.4473 24.5098 13.002 24.5039 12.7266 24.2285L7.88674 19.3477C7.61135 19.0723 7.61721 18.627 7.8926 18.3516L9.55666 16.6992C9.83205 16.4238 10.2774 16.4297 10.5528 16.7051L13.2481 19.4238L19.459 13.2598C19.7344 12.9844 20.1797 12.9902 20.4551 13.2656L22.1074 14.9297C22.3828 15.2109 22.377 15.6504 22.1016 15.9258Z",
  fill: "#203972"
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "modal-title",
    id: "exampleModalLongTitle"
  }, " Atendimentos "),
  /*#__PURE__*/_createElementVNode("p", null, "Veja a lista de atendimentos")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_14 = {
  class: "modal-body p-8",
  id: "modalBody"
}
const _hoisted_15 = {
  class: "ps-0",
  style: {"border-top":"0.5px solid #b5b5c3","padding-right":"0.5rem"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "d-flex justify-content-between pt-5" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs-3 fw-bolder",
    style: {"color":"#b5b5c3"}
  }, "Placa"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs-3 fw-bolder",
    style: {"color":"#b5b5c3"}
  }, "Status"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs-3 fw-bolder",
    style: {"color":"#b5b5c3"}
  }, "Busca")
], -1))
const _hoisted_17 = { style: {"height":"20.5rem","overflow":"auto"} }
const _hoisted_18 = { class: "col-4 fs-5" }
const _hoisted_19 = { class: "col-4 fs-5 d-flex justify-content-center" }
const _hoisted_20 = { class: "col-4 fs-5 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_11))
              ]),
              _hoisted_12
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("ul", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atendimentosRender, (atendimentoEmAndamento, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "d-flex justify-content-between pt-4 pb-4",
                    key: key
                  }, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(!atendimentoEmAndamento.placa ? "-" : atendimentoEmAndamento.placa), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(atendimentoEmAndamento.status), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(!atendimentoEmAndamento.placa ? "Busca manual" : "Busca placa"), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}